/* eslint-disable prefer-rest-params */
/* eslint-disable no-undef */
/* eslint-disable prefer-spread */

import React from 'react'

import { createMenuItems, switchColumChoser } from './utils'
import { dateToTime } from '../../../libs/msToTime'

export const KEY_DATA_GRID_STATE_IN_LS = 'rtvDataGridState'

export const columns = (texts = {}) => [
  {
    caption: texts['column-visitor.name'],
    dataField: 'visitor.name',
    keyForRequest: 'visitor.name',
    dataPaths: ['visitor', 'name'],
    dataType: 'string',
    editorOptions: { showClearButton: true },
  },
  {
    caption: texts['column-operators.nickname'],
    dataField: 'agents',
    keyForRequest: 'participantOperators.nickname',
    dataPaths: ['agents'],
    filterOperations: ['contains', 'notcontains'],
    dataType: 'string',
    editorOptions: { showClearButton: true },
    calculateFilterExpression(value, operation, target) {
      if (target === 'headerFilter' && value !== null) {
        return ['agents', 'contains', value]
      }
      return this.defaultCalculateFilterExpression.apply(this, arguments);
    },
  },
  {
    caption: texts['column-startDate'],
    dataField: 'startDate',
    keyForRequest: 'startDate',
    dataPaths: ['startDate'],
    dataType: 'date',
    sortOrder: 'desc',
    format: 'dd/MM/yyyy',
    editorOptions: { showClearButton: true },
    // groupInterval: 'day',
    // headerFilter: {
    //   groupInterval: 'day',
    // },
  },
  {
    caption: texts['column-visitor.visitorEmail'],
    dataField: 'visitor.email',
    keyForRequest: 'visitor.email',
    dataPaths: ['visitor', 'email'],
    dataType: 'string',
    visible: false,
    editorOptions: { showClearButton: true },
  },
  {
    caption: texts['column-visitor.userAgent.browserName'],
    dataField: 'visitor.userAgent.browserName',
    keyForRequest: 'visitor.userAgent.browserName',
    dataPaths: ['visitor', 'userAgent', 'browserName'],
    dataType: 'string',
    visible: false,
    editorOptions: { showClearButton: true },
    calculateFilterExpression(value, operation, target) {
      if (target === 'headerFilter' && value === null) {
        return ['visitor.userAgent.browserName', operation, '']
      }
      return this.defaultCalculateFilterExpression.apply(this, arguments);
    },
    // allowSorting: false /* remove this later */,
    // allowGrouping: false, /* remove this later */
    // allowHeaderFiltering: false, /* remove this later */
  },
  {
    caption: texts['column-visitor.userAgent.osName'],
    dataField: 'visitor.userAgent.osName',
    keyForRequest: 'visitor.userAgent.osName',
    dataPaths: ['visitor', 'userAgent', 'osName'],
    dataType: 'string',
    visible: false,
    editorOptions: { showClearButton: true },
    calculateFilterExpression(value, operation, target) {
      if (target === 'headerFilter' && value === null) {
        return ['visitor.userAgent.osName', operation, '']
      }
      return this.defaultCalculateFilterExpression.apply(this, arguments);
    },
    // allowSorting: false, /* remove this later */
    // allowGrouping: false, /* remove this later */
    // allowHeaderFiltering: false, /* remove this later */
  },
  {
    caption: texts['column-visitor.calledFrom'],
    dataField: 'visitor.calledFrom',
    keyForRequest: 'visitor.calledFrom',
    dataPaths: ['visitor', 'calledFrom'],
    dataType: 'string',
    visible: false,
    editorOptions: { showClearButton: true },
    // allowGrouping: false, /* remove this later */
    // allowHeaderFiltering: false, /* remove this later */
  },
  {
    caption: texts['column-visitor.ipAddress'],
    dataField: 'visitor.ipAddress',
    keyForRequest: 'visitor.ipAddress',
    dataPaths: ['visitor', 'ipAddress'],
    filterOperations: ['=', '<>', '<', '>', '<=', '>=', 'contains', 'notcontains', 'startswith', 'endswith'],
    selectedFilterOperation: 'contains',
    dataType: 'string',
    visible: false,
    editorOptions: { showClearButton: true },
    allowSorting: false, /* remove this later */
  },
  {
    caption: texts['column-chatDuration'],
    dataField: 'chatDuration',
    keyForRequest: 'chatDuration',
    dataPaths: ['chatDuration'],
    dataType: 'datetime',
    format: 'HH:mm:ss',
    filterOperations: ['=', '<>', '<', '>', '<=', '>=', 'between'],
    filter: true,
    visible: false,
    editorOptions: { showClearButton: true },
    groupInterval: 300000,
    calculateFilterExpression(value, operation, target) {
      if (target === 'headerFilter' && ~value.indexOf(' - ')) { /* between */
        const values = value.split(' - ')
        return [
          ['chatDuration', '>=', values[0]],
          'and',
          ['chatDuration', '<=', values[1]],
        ];
      }
      if (target === 'filterRow') {
        if (operation === 'between') {
          return [
            ['chatDuration', '>=', dateToTime(value[0])],
            'and',
            ['chatDuration', '<=', dateToTime(value[1])],
          ];
        }
        return ['chatDuration', operation, dateToTime(value)]
      }
      if (value === 'N/A') {
        return ['chatDuration', operation, null]
      }
      return this.defaultCalculateFilterExpression.apply(this, arguments);
    },
    calculateCellValue: rowData => (rowData.endDate > 0 ? rowData.chatDuration : 'N/A'),
    headerFilter: {
      groupInterval: null,
    },
  },
  {
    caption: texts['column-messagesCount'],
    dataField: 'messagesCount',
    keyForRequest: 'messagesCount',
    dataPaths: ['messagesCount'],
    dataType: 'number',
    visible: false,
    editorOptions: { showClearButton: true },
    alignment: 'left',
    groupInterval: 10,
    headerFilter: {
      groupInterval: 10,
    },
    groupCellRender: data => (<div>{`${texts['column-messagesCount']}: ${data.key[0]}`}</div>),
  },
  {
    caption: texts['column-charsCount'],
    dataField: 'charsCount',
    keyForRequest: 'charsCount',
    dataPaths: ['charsCount'],
    dataType: 'number',
    visible: false,
    editorOptions: { showClearButton: true },
    alignment: 'left',
    groupInterval: 100,
    headerFilter: {
      groupInterval: 100,
    },
    groupCellRender: data => (<div>{`${texts['column-charsCount']}: ${data.key[0]}`}</div>),
  },
]

/* toolbar */
export const onToolbarPreparing =
({
  texts,
  dataGridRef,
  clearFilter,
  removeSelectedTranscripts,
  onExporting,
}) => event => {
  event.toolbarOptions.items = [
    event.toolbarOptions.items[0],
    {
      cssClass: 'clear isDisableIfIsNoFilteringSortingGroupingAndSelected',
      locateInMenu: 'auto',
      location: 'after',
      name: 'clear',
      showText: 'inMenu',
      sortIndex: 50,
      widget: 'dxButton',
      options: {
        hint: texts['clear'],
        icon: 'refresh',
        locateInMenu: 'auto',
        text: texts['clear'],
        onClick() {
          clearFilter()
        },
      },
    },
    {
      cssClass: 'export',
      locateInMenu: 'auto',
      location: 'after',
      menuItemTemplate: createMenuItems,
      name: 'export',
      sortIndex: 30,
      widget: 'dxDropDownButton',
      options: {
        disabled: false,
        displayExpr: 'text',
        hint: texts['tooltip-export'],
        icon: 'refresh',
        dropDownContentTemplate: createMenuItems,
        items: [
          {
            text: texts['tooltip-export-all-transcripts-to-xlsx'],
            icon: 'exportxlsx',
            onClick() {
              onExporting({
                dataGridRef,
                typeExportedFiles: 'xlsx',
                isExportAll: true,
              })
            },
          },
          {
            text: texts['tooltip-export-selected-transcripts-to-xlsx'],
            icon: 'exportselected',
            cssClass: 'isDisableIfNothingIsSelected',
            onClick() {
              onExporting({
                dataGridRef,
                typeExportedFiles: 'xlsx',
              })
            },
          },
          {
            text: texts['tooltip-export-all-transcripts-to-txt'],
            icon: 'txtfile',
            onClick() {
              onExporting({
                dataGridRef,
                typeExportedFiles: 'txt',
                isExportAll: true,
              })
            },
          },
          {
            text: texts['tooltip-export-selected-transcripts-to-txt'],
            icon: 'exportselected',
            cssClass: 'isDisableIfNothingIsSelected',
            onClick() {
              onExporting({
                dataGridRef,
                typeExportedFiles: 'txt',
              })
            },
          },
        ],
        rtlEnabled: false,
        stylingMode: 'text',
        templatesRenderAsynchronously: true,
      },
    },
    {
      cssClass: 'remove isDisableIfNothingIsSelected',
      locateInMenu: 'auto',
      location: 'after',
      name: 'remove',
      showText: 'inMenu',
      sortIndex: 60,
      widget: 'dxButton',
      options: {
        hint: texts['remove'],
        icon: 'trash',
        locateInMenu: 'auto',
        text: texts['remove'],
        onClick() {
          removeSelectedTranscripts()
        },
      },
    },
    {
      cssClass: 'colum-choser',
      locateInMenu: 'auto',
      location: 'after',
      name: 'colum-choser',
      showText: 'inMenu',
      sortIndex: 40,
      widget: 'dxButton',
      options: {
        hint: texts['column-chooser'],
        icon: 'columnchooser',
        locateInMenu: 'auto',
        text: texts['column-chooser'],
        templatesRenderAsynchronously: true,
        onClick: switchColumChoser(dataGridRef),
      },
    },
  ]
}
